import * as React from 'react';

function SvgIconAvatarDefault(props) {
  return (
    <svg
      width={100}
      height={100}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path d="M100 50A50 50 0 110 50a50 50 0 01100 0" id="icon-avatar-default_svg__a" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="icon-avatar-default_svg__b" fill="#fff">
          <use xlinkHref="#icon-avatar-default_svg__a" />
        </mask>
        <use fill="#F8F8F6" xlinkHref="#icon-avatar-default_svg__a" />
        <g mask="url(#icon-avatar-default_svg__b)">
          <path
            d="M13.72 90.4a1.67 1.67 0 01-.17-1.79l.26-.5c7.35-13.92 21.05-22.56 35.76-22.58 14.77.02 28.47 8.66 35.8 22.57l.28.51c.3.58.23 1.28-.17 1.8-9.01 11.7-22.08 18.4-35.85 18.42-13.83-.01-26.9-6.73-35.91-18.43z"
            fill="#FCCE01"
          />
          <path
            d="M71.93 41.71l4.9-2.01v14.5l.03.26a3.8 3.8 0 00-2.26 3.45 3.8 3.8 0 003.77 3.78 3.8 3.8 0 003.78-3.78 3.8 3.8 0 00-2.26-3.45l.02-.26V38.44l5.86-2.41a3.2 3.2 0 002.18-3.01c0-1.26-.83-2.43-2.15-3L51.2 16.35c-.93-.4-1.99-.4-2.87-.02L13.51 29.98a3.2 3.2 0 00-2.25 3.04c0 1.32.8 2.5 2.12 3.06l14.1 6.13 2.76 5.99a1.67 1.67 0 002.42.7c.1-.07 9.56-6.2 17.12-6.2h.17c11.05.14 16.76 6.22 16.81 6.28a1.67 1.67 0 002.81-.57l2.36-6.7z"
            fill="#4C4C4C"
          />
          <path
            d="M49.6 77.2c-11.4 0-20.67-9.61-20.67-21.44 0-2.68.47-5.3 1.4-7.77.1-.27.28-.5.52-.67.31-.22 7.75-5.4 12.22-6.08 4.56-.69 10.99-.93 14.35.14 2.67.85 8.82 3.25 10.78 5.23 2.13 2.16 2.1 5.42 2.08 8.29v.86C70.27 67.6 61 77.2 49.6 77.2z"
            fill="#FFF8DA"
          />
          <path
            d="M43.73 57.95a2.45 2.45 0 01-2.47-2.43c0-1.35 1.1-2.43 2.47-2.43a2.45 2.45 0 012.47 2.43c0 1.34-1.1 2.43-2.47 2.43zm15.1-2.43c0 1.34-1.11 2.43-2.48 2.43a2.45 2.45 0 01-2.47-2.43c0-1.35 1.1-2.43 2.47-2.43a2.45 2.45 0 012.48 2.43zm-3.85 6.4a4.9 4.9 0 01-4.94 4.86 4.9 4.9 0 01-4.94-4.86h9.88z"
            fill="#63656A"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgIconAvatarDefault;
